module.exports = __webpack_public_path__ + "img/projections-icon.a53adba5.svg";